var map = {
	"./Banner.jpg": 7142,
	"./sponsor1.png": 8617,
	"./sponsor10.png": 5170,
	"./sponsor11.jpg": 1201,
	"./sponsor12.jpg": 3611,
	"./sponsor13.jpg": 6168,
	"./sponsor14.svg": 5904,
	"./sponsor14new.svg": 5067,
	"./sponsor15.jpg": 660,
	"./sponsor15.png": 7546,
	"./sponsor16.png": 7226,
	"./sponsor17.png": 6869,
	"./sponsor18.svg": 2364,
	"./sponsor19.jpg": 1411,
	"./sponsor2.png": 1517,
	"./sponsor20.jpg": 5184,
	"./sponsor21.png": 8469,
	"./sponsor22.jpg": 6512,
	"./sponsor23.jpg": 2164,
	"./sponsor24.svg": 3752,
	"./sponsor25.jpg": 2600,
	"./sponsor26.png": 1136,
	"./sponsor27.jpg": 7783,
	"./sponsor28.png": 5450,
	"./sponsor29.svg": 3489,
	"./sponsor3.png": 2359,
	"./sponsor30.jpg": 2910,
	"./sponsor31.png": 6887,
	"./sponsor32.jpg": 1162,
	"./sponsor33.png": 2079,
	"./sponsor34.png": 8406,
	"./sponsor35.svg": 4909,
	"./sponsor36.png": 7007,
	"./sponsor37.png": 4602,
	"./sponsor38.png": 6874,
	"./sponsor39.png": 5791,
	"./sponsor4.png": 6953,
	"./sponsor40.png": 5961,
	"./sponsor41.jpg": 5819,
	"./sponsor42.svg": 7122,
	"./sponsor43.jpg": 1754,
	"./sponsor43.svg": 6270,
	"./sponsor44.svg": 4608,
	"./sponsor45.png": 9436,
	"./sponsor46.svg": 6193,
	"./sponsor47.png": 1271,
	"./sponsor48.svg": 9794,
	"./sponsor49.svg": 7842,
	"./sponsor5.png": 8181,
	"./sponsor50.png": 7231,
	"./sponsor6.png": 5186,
	"./sponsor7.jpg": 2206,
	"./sponsor8.png": 1819,
	"./sponsor9.svg": 864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6290;